import type { SocketStatus } from "../hooks";

/* A dropped socket used to be a small grey pill among four others.

   It is the one condition on this page where the panel is lying to you: the
   history stops updating, the queue stops moving, and nothing that arrives in
   the meantime will ever be shown. Messages still send — the POST does not need
   the socket — so this says that too, rather than implying the panel is dead. */
export function ConnectionBanner({ status }: { status: SocketStatus }) {
  if (status === "live") return null;

  const connecting = status === "connecting";
  return (
    <div className={"banner" + (connecting ? "" : " warn")} role="status">
      <span className="dot off" aria-hidden="true"></span>
      <span>
        {connecting
          ? "Connecting to the live feed…"
          : "Reconnecting…"}
      </span>
    </div>
  );
}
